export default {
  filters: {
    $_powerFilter_kw(value) {
      return parseInt(value).toLocaleString() + ' kW'
    },
    $_powerFilter_kwh(value) {
      return parseInt(value).toLocaleString() + ' kWh'
    }
  },

  methods: {
    $_powerMethod_kw(value) {
      if (value != null) return parseInt(value).toLocaleString() + ' kW'
      return '-'
    },
    $_powerMethod_kwh(value) {
      if (value != null) return parseInt(value).toLocaleString() + ' kWh'
      return '-'
    }
  }
}
